/* eslint-disable @angular-eslint/directive-selector */
import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[ngx-datatable-group-header-template]'
})
export class DatatableGroupHeaderTemplateDirective {
  template = inject<TemplateRef<unknown>>(TemplateRef);

}
